import { default as au } from './au'
import { default as be } from './be'
import { default as ca } from './ca'
import { default as cn } from './cn'
import { default as de } from './de'
import { default as dk } from './dk'
import { default as es } from './es'
import { default as eu } from './eu'
import { default as fr } from './fr'
import { default as hk } from './hk'
import { default as id } from './id'
import { default as india } from './in'
import { default as jp } from './jp'
import { default as kr } from './kr'
import { default as my } from './my'
import { default as nl } from './nl'
import { default as ph } from './ph'
import { default as ru } from './ru'
import { default as se } from './se'
import { default as sg } from './sg'
import { default as th } from './th'
import { default as tw } from './tw'
import { default as uk } from './uk'
import { default as us } from './us'
import { default as vn } from './vn'
import { default as it } from './it'
import { default as at } from './at'
import { default as fi } from './fi'
import { default as gr } from './gr'
import { default as ie } from './ie'
import { default as lu } from './lu'
import { default as pl } from './pl'
import { default as pt } from './pt'
import { default as si } from './si'
import { default as sk } from './sk'
import { default as lt } from './lt'
import { default as lv } from './lv'
import { default as ee } from './ee'
import { default as cz } from './cz'
import { default as hu } from './hu'
import { default as ro } from './ro'
import { default as bg } from './bg'
import { default as hr } from './hr'

export const locales = {
  au,
  be,
  ca,
  cn,
  de,
  dk,
  es,
  eu,
  fr,
  hk,
  id,
  in: india,
  jp,
  kr,
  my,
  nl,
  ph,
  ru,
  se,
  sg,
  th,
  tw,
  uk,
  us,
  vn,
  it,
  'eu-at': at,
  'eu-fi': fi,
  'eu-gr': gr,
  'eu-ie': ie,
  'eu-lu': lu,
  'eu-pl': pl,
  'eu-pt': pt,
  'eu-si': si,
  'eu-sk': sk,
  'eu-lt': lt,
  'eu-lv': lv,
  'eu-ee': ee,
  'eu-cz': cz,
  'eu-hu': hu,
  'eu-ro': ro,
  'eu-bg': bg,
  'eu-hr': hr,
}
